<template>
    <div class="Fundingsupport">
        <div class="Addfunds">
            <el-button size="mini" type="primary" @click="dialogVisible=true">添加专利</el-button>
        </div>
        <el-table 
            :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" 
            style="width: 100%"
            stripe
            :cell-style="{'text-align':'center'}"
            :header-cell-style="{background:'#f2f2f2',color:'#606266','text-align':'center'}"
        >   
            <el-table-column type="index" width="100" label="#"></el-table-column>
            <el-table-column prop="patNumber" label="申请（专利）号"></el-table-column>
            <el-table-column prop="patName" label="申请（专利权）人"></el-table-column>
            <el-table-column prop="inventName" label="发明（设计）名称"></el-table-column><el-table-column prop="level" label="操作" width="150px">
                <template slot-scope="scope">
                    <el-button @click="deleted(scope.row)" size="mini" type="danger">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="24">
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 15, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableData.length">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <!-- 弹窗 -->
        <div class="Fundspopup">
            <el-dialog
                title="填写专利信息"
                :visible.sync="dialogVisible"
                width="580px"
                :before-close="handleClose"
                :show-close="false">
                <i class="el-icon-close closei" @click="closei()"></i>
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px">
                    <el-form-item label="申请(专利)号" prop="patNumber">
                        <el-input v-model="ruleForm.patNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="申请(专利权)人" prop="patName">
                        <el-input v-model="ruleForm.patName"></el-input>
                    </el-form-item>
                    <el-form-item label="发明(设计)名称" prop="inventName">
                        <el-input v-model="ruleForm.inventName"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="addqued('ruleForm')">确 定</el-button>
                    <el-button size="small" @click="closei()">取 消</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            tableData:[],
            pageSize:10,
            totalnum:0,
            currentPage:1,
            dialogVisible:false,
            ruleForm:{
                patNumber:'',
                patName:'',
                inventName:'',
            },
            rules:{
                patNumber:[
                    { required: true, message: '请输入申请(专利)号', trigger: 'blur' }
                ],
                patName:[
                    { required: true, message: '请输入申请(专利权)人', trigger: 'blur' }
                ],
                inventName:[
                    { required: true, message: '请输入发明(设计)名称', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        getapp(){
            this.axios.patentsList({
                params:{
                    itemId:this.$store.state.itemId
                }
            }).then(res=>{
                if(res.data.code==200){
                    this.tableData = res.data.rows
                }else{
                    this.tableData  = []
                }
            }).catch(err=>{

            })
        },
        //添加确定
        addqued(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.itemId = this.$store.state.itemId
                    this.axios.patentsAdd(
                        this.ruleForm
                    ).then(res=>{
                        if(res.data.code==200){
                            this.dialogVisible = false
                            this.$refs[formName].resetFields();
                            this.getapp()
                        }
                    }).catch(err=>{

                    })
                }else{
                    return false
                }
            })
        },
        // 删除
        deleted(rows){
            this.axios.patentsDelete({
                params:{
                    patId:rows.patId
                }
            }).then(res=>{
                if(res.data.code==200){
                    this.getapp()
                }
            }).catch(err=>{

            })
        },
        handleAvatarSuccess(res, file) {
            this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
        },
        closei(){
            this.dialogVisible = false
        },
        handleClose(done){
            console.log(done)
        },
        handleSizeChange(val){
            this.pageSize = val;
        },
        handleCurrentChange(val){
            this.currentPage = val;
        },
    },
    mounted () {
        this.getapp()
    }
}
</script>
<style scoped>
@import './../../assets/css/student/Fundingsupport.css';
</style>
<style>
.Fundingsupport .el-table__body-wrapper{
    min-height: calc(100vh - 340px);
}
.Fundingsupport .el-table__empty-block{
    min-height: calc(100vh - 340px);
}
.Fundspopup .el-dialog__header{
    padding: 0 0 0 20px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    border-bottom: 1px solid #eaecee;
    background: #409EFF;
}
.Fundspopup .el-dialog__title{
    font-size: 14px;
    color: #fff;
}
.Fundspopup .el-dialog__footer{
    text-align: center;
}
.Fundspopup .el-form-item__content{
    width: 350px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>